import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable, toJS } from 'mobx';
import { getDisplayDate } from "../../../libs/date";

@inject('parameterStore')
@observer
class StationFullObservationTable extends React.Component {

  @observable pagination_index = 0;
  @observable pagination_index_max = 0;
  @observable pagination_size = 50;
  @observable stationObservationByTimestamp = {};

  componentWillMount() {
    this.stationObservationByTimestamp = this.observationByTimestamp(this.props.stationObservation);
  }


  componentWillReceiveProps(nextProps) {
    this.stationObservationByTimestamp = this.observationByTimestamp(nextProps.stationObservation);
    this.pagination_index_max = Math.floor(Object.keys(this.stationObservationByTimestamp).length / this.pagination_size)
  }


  observationByTimestamp = stations => {
    return stations.map(station => {
      let observations = {};
      if (!!station.parameters) station.parameters.forEach(parameter => {
        if (!!parameter.data) parameter.data.forEach(item => {
          if (!observations[item.time]) {
            observations[item.time] = {
              [parameter.parameter_name]: {
                value: !!item.value || +item.value === 0 ? Math.round(item.value * 100) / 100 : '-',
                qc_flag: item.qc_flag
              }
            };
          } else {
            observations[item.time][parameter.parameter_name] = {
              value: !!item.value || +item.value === 0 ? Math.round(item.value * 100) / 100 : '-',
              qc_flag: item.qc_flag
            };
          }
        })
      });
      delete station.parameters;
      station.observations = observations;
      return station;
    })[0].observations;
  };

  getProperFlag = flag => {
    let _flag = flag.toString().split('');
    let properFlag = [];
    for (let i = 0; i < 4 - _flag.length; i++) {
      properFlag.push(0);
    }
    _flag.map(x => {
      properFlag.push(+x);
    });
    return properFlag.join('');
  };

  render() {
    const { toggleParameterShow, parameters, showQC, pinGraph } = this.props;
    // let stationObservationByTimestamp = this.observationByTimestamp(stationObservation).slice();
    // console.log(this.props.parameters);
    return (
      <div>
        <div className='DataTable'>
          <table>
            <thead>
              <tr>
                <th style={{ background: '#3c8dbc', height: '42px', lineHeight: '42px', position: 'sticky', top: pinGraph ? 428 : 0 }} rowSpan={2}>Date & Time</th>
                {parameters.map((item, i) => <th style={{ background: '#3c8dbc', position: 'sticky', top: pinGraph ? 428 : 0 }} key={`head-${item.id}`}>
                  {item.parameter_code}{item.unit ? ` (${item.unit})` : ''}
                  <br /><br />
                  <input type='checkbox' checked={item.show} onChange={() => toggleParameterShow(item.id)} />
                  {/*<br/>{!!item.parameter_unit && !!item.parameter_unit.symbol.trim() ? ` (${item.parameter_unit.symbol})` : ''}*/}
                </th>
                )}
              </tr>
            </thead>
            <tbody>{Object.keys(this.stationObservationByTimestamp).sort((a, b) => new Date(a).valueOf() < new Date(b).valueOf() ? -1 : 1).slice(this.pagination_index * this.pagination_size, (this.pagination_index + 1) * this.pagination_size).map(time => (<tr key={time}>
              <th style={{}}>{getDisplayDate(time)}</th>
              {parameters.map(item => {
                let parameterData = this.stationObservationByTimestamp[time][item.parameter_name];
                if (!parameterData) return <td style={{}} key={`body-${item.id}`}>{ }</td>;
                return <td key={`body-${item.id}`} style={{}}>{parameterData.value}{showQC && parameterData.qc_flag ? ` [${this.getProperFlag(parameterData.qc_flag)}]` : ''}</td>
              })}
            </tr>))}</tbody>
          </table>
        </div>
        <div>
          <span className='button button-inactive' onClick={() => this.pagination_index = 0}><i className='white fa fa-backward' /></span>
          <span className='button button-inactive' onClick={() => this.pagination_index -= (this.pagination_index === 0 ? 0 : 1)}><i className='white fa fa-caret-left' /></span>
          <b style={{ margin: '0px 5px' }}>{this.pagination_index + 1} of {Math.ceil(Object.keys(this.stationObservationByTimestamp).length / this.pagination_size)}</b>
          <span className='button button-inactive' onClick={() => this.pagination_index += (this.pagination_index + 1 > this.pagination_index_max ? 0 : 1)}><i className='white fa fa-caret-right' /></span>
          <span className='button button-inactive' onClick={() => this.pagination_index = this.pagination_index_max}><i className='white fa fa-forward' /></span>
        </div>
      </div>
    );
    // return (
    //   <div className='outer'>
    //     <div className='inner'>
    //       <table className='horizontal'>
    //         <thead>
    //         <tr>
    //           <th style={{height: '42px', lineHeight: '42px'}} rowSpan={2}>Date & Time</th>
    //           {parameters.map((item, i) => <td style={{height: 'unset', lineHeight: 'unset'}} key={`head-${item.id}`}>
    //             {item.parameter_name}{item.unit ? ` (${item.unit})` : ''}
    //             <br/><br/>
    //             <input type='checkbox' checked={item.show} onChange={() => toggleParameterShow(item.id)}/>
    //             {/*<br/>{!!item.parameter_unit && !!item.parameter_unit.symbol.trim() ? ` (${item.parameter_unit.symbol})` : ''}*/}
    //             </td>
    //           )}
    //         </tr>
    //         </thead>
    //         <tbody>{Object.keys(this.stationObservationByTimestamp).slice(this.pagination_index * this.pagination_size, (this.pagination_index + 1) * this.pagination_size).map(time => (<tr key={time}>
    //           <th style={{height: 'unset', lineHeight: 'unset', borderBottom: '1px solid #d7d7d7'}}>{getDisplayDate(time)}</th>
    //           {parameters.map(item => {
    //             let parameterData = this.stationObservationByTimestamp[time][item.parameter_name];
    //             if(!parameterData) return <td style={{height: 'unset', lineHeight: 'unset'}} key={`body-${item.id}`}>{}</td>;
    //             return <td key={`body-${item.id}`} style={{height: 'unset', lineHeight: 'unset'}}>{parameterData.value}{showQC && parameterData.qc_flag ? ` [${parameterData.qc_flag}]` : ''}</td>
    //           })}
    //         </tr>))}</tbody>
    //       </table>
    //     </div>
    //     <div>
    //       <button className='button' onClick={() => this.pagination_index = 0}><span className='white fa fa-backward'/></button>
    //       <button className='button' onClick={() => this.pagination_index -= (this.pagination_index === 0  ? 0 : 1)}><span className='white fa fa-caret-left'/></button>
    //       <span>{this.pagination_index}</span>
    //       <button className='button' onClick={() => this.pagination_index += (this.pagination_index + 1 > this.pagination_index_max ? 0 : 1)}><span className='white fa fa-caret-right'/></button>
    //       <button className='button' onClick={() => this.pagination_index = this.pagination_index_max}><span className='white fa fa-forward'/></button>
    //     </div>
    //   </div>
    // );
  }
}

export default StationFullObservationTable;


// WEBPACK FOOTER //
// ./src/components/Station/FullObservation/StationFullObservationTable.js